export const ABVEHICLES_BASE_PATH = `/vehicles-abandoned`;
export const RoutesList = {
  ABVEHICLES_HOME: ABVEHICLES_BASE_PATH,
  INVOLVED_IN_ACCIDENT: ABVEHICLES_BASE_PATH + '/involved-in-accident',
  DANGEROUS_POSITION: ABVEHICLES_BASE_PATH + '/dangerous-position',
  WHAT_HAPPENS_NEXT: ABVEHICLES_BASE_PATH + '/what-happens-next',
  CONTACT_POLICE: ABVEHICLES_BASE_PATH + '/contact-police',
  CONTACT_FIRE_BRIGADE: ABVEHICLES_BASE_PATH + '/contact-fire-brigade',
  LEAKING: ABVEHICLES_BASE_PATH + '/leaking',
  UPLOAD_PHOTO: ABVEHICLES_BASE_PATH + '/upload-photo',
  ISSUE_TYPE: ABVEHICLES_BASE_PATH + '/issue-type',
  HOW_LONG: ABVEHICLES_BASE_PATH + '/how-long',
  VEHICLE_DETAILS: ABVEHICLES_BASE_PATH + '/vehicle-details',
  ISSUE_LOCATION: ABVEHICLES_BASE_PATH + '/issue-location',
  REPORT_TO_TFL: ABVEHICLES_BASE_PATH + '/report-to-tfl',
  EMAIL_CONFIRMATION_REPORT:
    ABVEHICLES_BASE_PATH + '/email-confirmation-report',
  YOUR_DETAILS: ABVEHICLES_BASE_PATH + '/your-details',
  CONFIRMATION: ABVEHICLES_BASE_PATH + '/confirmation',
  NOT_FOUND: '*',
  INTERNAL_SERVER_ERROR: '/500',
};

export const steps = [
  {
    label: 'Issue type',
    urlPaths: [
      RoutesList.INVOLVED_IN_ACCIDENT,
      RoutesList.DANGEROUS_POSITION,
      RoutesList.LEAKING,
    ],
  },
  {
    label: 'Photos',
    urlPaths: [RoutesList.UPLOAD_PHOTO],
  },
  {
    label: 'Issue details',
    urlPaths: [
      RoutesList.ISSUE_TYPE,
      RoutesList.HOW_LONG,
      RoutesList.VEHICLE_DETAILS,
    ],
  },
  {
    label: 'Location',
    urlPaths: [RoutesList.ISSUE_LOCATION, RoutesList.REPORT_TO_TFL],
  },
  {
    label: 'Your details',
    urlPaths: [RoutesList.EMAIL_CONFIRMATION_REPORT, RoutesList.YOUR_DETAILS],
  },
];
